Vue.component('addStreamer', {
    template: templates.addStreamer,
    data() {
      return {
        model: {
          streamerOption: false,
          searchResults: [],
          removeSearchResults: [],
          addInputValue: '',
          removeInputValue: '',
          streamer: {
            months_subscription: 0,
            userTier: 0
          },
          userTiers: [
            { value: '2', name: 'Prime Tier' },
            { value: '3', name: 'Ultra Tier' },
            { value: '4', name: 'Legendary Tier' },
          ],
        }
      }
    },
    mounted() {
      this.setupInputTracking();
    },
    methods: {
      setupInputTracking() {
        const c = this;
        
        // Track add input changes
        $('[name="streamer-user"]').on('input', function() {
          const currentValue = $(this).val();
          const previousValue = c.model.addInputValue;
          
          // Deletion detected
          if (currentValue.length < previousValue.length) {
            console.log('Deletion in add input:', {
              previous: previousValue,
              current: currentValue,
              deleted: previousValue.length - currentValue.length
            });
            
            // Completely cleared
            if (currentValue.length === 0) {
              console.log('Add input completely cleared');
              c.model.searchResults = [];
              utils.alert.error('Search cleared');
            }
            c.model.streamerOption = false
          }
          
          c.model.addInputValue = currentValue;
        });
        
        // Track remove input changes
        $('[name="remove-streamer-user"]').on('input', function() {
          const currentValue = $(this).val();
          const previousValue = c.model.removeInputValue;
          
          if (currentValue.length < previousValue.length) {
            console.log('Deletion in remove input:', {
              previous: previousValue,
              current: currentValue,
              deleted: previousValue.length - currentValue.length
            });
            
            if (currentValue.length === 0) {
              console.log('Remove input completely cleared');
              c.model.removeSearchResults = [];
              utils.alert.info('Search cleared');
            }
          }
          
          c.model.removeInputValue = currentValue;
        });
      },
      
      searchUsers(condition) {
        const c = this;
        let names = [];
        let twitchDisplayName = '';
        
        if(condition == 'add'){
          twitchDisplayName = $('[name="streamer-user"]').val();
        }
        else{
          twitchDisplayName = $('[name="remove-streamer-user"]').val();
        }

        // Don't search if input is empty
        if (!twitchDisplayName || twitchDisplayName.trim() === '') {
          if(condition == 'add'){
            c.model.searchResults = [];
          } else {
            c.model.removeSearchResults = [];
          }
          return;
        }

        userService.search({twitchDisplayName: twitchDisplayName})
          .then(function (response) {
            if(condition == 'add'){
              c.model.searchResults = response.data;
            }else{
              c.model.removeSearchResults = response.data;
            }
        
            for (let data of response.data) {
              names.push(data.twitchDisplayName);
            }

            if(condition == 'add'){
              $('[name="streamer-user"]').autocomplete({
                source: names,
                select: function(event, ui) {
                  c.model.streamerOption = true
                  utils.alert.success('User selected: ' + ui.item.value);
                  return true;
                }
              });
            } else {
              $('[name="remove-streamer-user"]').autocomplete({
                source: names,
                select: function(event, ui) {
                  utils.alert.success('User selected: ' + ui.item.value);
                  return true;
                }
              });
            }
          })
          .catch(function (error) {
            console.error('Error searching users:', error);
          });
      },
      save() {
        const c = this;
        const twitchDisplayName = $('[name="streamer-user"]').val();
  
        c.getUserId(twitchDisplayName, 'add', function(twitchId) {
  
          if (!twitchId) {
            utils.alert.error('User is required!');
            return;
          }

          if(c.model.streamer.userTier === 0){
            utils.alert.error('user tier is required!');
            return;
          }

          if(c.model.streamer.months_subscription === 0){
            utils.alert.error('user months subscription is required!');
            return;
          }
  
          const data = {
            twitchId: twitchId,
            subscription: c.model.streamer.months_subscription,
            tier: c.model.streamer.userTier
          }
  
          userService.addStreamer(data)
            .then(function (response) {
              c.reset();
              utils.alert.success(response.data.message)
            })
            .catch(function (error) {
              //console.log(error);
            });
  
        });
      },
      removeStreamer(){
        const c = this;
        const twitchDisplayName = $('[name="remove-streamer-user"]').val();

        c.getUserId(twitchDisplayName, 'remove', function(twitchId) {

          if (!twitchId) {
            utils.alert.error('User required!');
            return;
          }

          const data = {
            twitchId: twitchId,
            isMod: false
          }

            userService.removeStreamer(data)
            .then(function (response) {
              utils.alert.success('Streamer Removed!');
              c.reset();
            })
            .catch(function (error) {
              //console.log(error);
            });

        });
      },
      getUserId(twitchDisplayName, condition, callback) {
        const c = this;
        for (let user of c.model.searchResults) {
          if (user.twitchDisplayName == twitchDisplayName) {
            callback(user.twitchId);
            return;
          }
        }
  
        twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {
  
          for (let data of userData) {
            callback(data.id);
            return;
          }
          
          callback(null);
  
        });
      },
      
      reset() {
        const c = this;
        $('[name="streamer-user"]').val('');
        $('[name="remove-streamer-user"]').val('');
        c.model.addInputValue = '';
        c.model.removeInputValue = '';
        c.model.searchResults = [];
        c.model.removeSearchResults = [];
        c.model.streamerOption = false;
      }
    }
});